async function fetchHtml(url: string): Promise<string | null> {
  try {
    const response = await fetch(url);
    if (response.ok) {
      const html = await response.text();
      return html;
    }
    return null;
  } catch (error) {
    return null;
  }
}

function parseHtml(html: string): Document | null {
  const parser = new DOMParser();
  try {
    const result = parser.parseFromString(html, 'text/html');
    return result;
  } catch (error) {
    return null;
  }
}

export async function fetchAndParseTerms(url: string): Promise<string> {
  const document = await fetchHtml(url);
  if (!document) return '';
  const parser = parseHtml(document);
  if (!parser) return ''; // error parsing
  const { body } = parser;
  const mainTag = Array.from(body.querySelectorAll('main#main')); // there's 2 <main>s on the page!
  if (mainTag.length === 0) return ''; // no main tag!
  return mainTag[0].innerHTML;
}
